import ModalContext from 'contexts/ModalContext'
import { useCallback, useContext } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import LineInfoCircleIcon from '../../../../../LuxKit/Icons/line/LineInfoCircleIcon'
import Label from '../../../../../LuxKit/Label'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import BodyText from 'LuxKit/Typography/BodyText'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { EmptyObject } from '../../../../lib/object/objectUtils'
import Clickable from 'components/Common/Clickable'

interface Props {
  offer: App.Offer | App.OfferSummary | App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary | App.CruiseOffer
  inclusions: Array<App.OfferInclusion>
  filters?: App.OfferListFilters
}

function ExperimentalHotelUpgradableInclusionsLabel(props: Props) {
  const {
    offer,
    inclusions,
    filters = EmptyObject,
  }: Props = props

  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const offerUrl = useOfferUrl(offer, { filters })

  const bonusInclusionsTitle = intl.formatMessage({
    id: 'bFI5fHJ5w8CbDuqbPimD',
    defaultMessage: 'Bonus inclusions on selected packages',
    description: 'Modal title for upgradable bonus inclusions on hotel search tile',
  })
  const viewOfferLabel = intl.formatMessage({
    id: 'VFeIVERXq9iWm72dAvC5',
    defaultMessage: 'View offer',
    description: 'CTA button in upgradable inclusions modal to view the offer',
  })
  const bonusInclusionsDescription = intl.formatMessage({
    id: 'sl2YqpLPsUU7NEnnsXQF',
    defaultMessage: 'Get more from your stay with added inclusions when you book select packages',
    description: 'Description in upgradable inclusions modal explaining bonus inclusions',
  })
  const upgradeLabelText = intl.formatMessage({
    id: 'YuWQV5WVbqhHWgF6p0TW',
    defaultMessage: 'Upgrade for bonus inclusions',
    description: 'Label on hotel search tile indicating bonus inclusions are available on upgrade',
  })

  const toggleModal = useCallback((event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    showModal(
      <Modal
        title={bonusInclusionsTitle}
        primaryActionText={viewOfferLabel}
        primaryActionTo={offerUrl}
      >
        <Group direction="vertical" gap={16}>
          <BodyText variant="medium">
            {bonusInclusionsDescription}
          </BodyText>
          <OfferInclusionsList
            inclusions={inclusions}
          />
        </Group>
      </Modal>,
    )
  }, [inclusions, offerUrl, showModal, bonusInclusionsTitle, viewOfferLabel, bonusInclusionsDescription])

  return (
    <Clickable onClick={toggleModal}>
      <Label
        kind="primary"
        variant="highlight-primary-dark"
        endIcon={<LineInfoCircleIcon />}
      >
        {upgradeLabelText}
      </Label>
    </Clickable>
  )
}

export default ExperimentalHotelUpgradableInclusionsLabel
